import { render, staticRenderFns } from "./TqDisplaySlidesData.vue?vue&type=template&id=45eb9b61&scoped=true&"
import script from "./TqDisplaySlidesData.vue?vue&type=script&lang=js&"
export * from "./TqDisplaySlidesData.vue?vue&type=script&lang=js&"
import style0 from "./TqDisplaySlidesData.vue?vue&type=style&index=0&id=45eb9b61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb9b61",
  null
  
)

export default component.exports